<template>
    <div class="content">
        <blockquote cite="https://boardgamegeek.com/boardgame/126042/nations">Nations is an intense historical board game for 1–5 players that takes 40 minutes per player to play. Players control the fate of nations from their humble start in prehistoric times until the beginning of World War I. The nations constantly compete against each other and must balance immediate needs, long-term growth, threats, and opportunities. <a href='https://boardgamegeek.com/boardgame/126042/nations'>BoardGameGeek</a></blockquote>
        <table class="table">
            <tbody>
            <!-- Player amount-->
            <tr>
                <td class="has-text-centered">
                    <label for="playerAmount" class="is-size-4">{{ $t("amount") }}</label>
                    <br>
                    <input type="range" id="playerAmount" class="is-fullwidth" v-model="playerAmount" value="3" min="1" max="5" />
                    <br>
                    <span class="is-size-5">{{ playerAmount }}</span>
                </td>
            </tr>

            <!-- Modules -->
            <tr>
                <td class="has-text-centered">
                    <span class="is-size-4">{{ $t("modules") }}</span>
                    <div>
                        <label for="core">Core</label>
                        &nbsp;
                        <input type="checkbox" id="core" name="core" checked="checked" v-model="coreCheck"/>
                        &nbsp;
                        <button @click="openModal({modalName: 'core'})" >{{ $t("showCore") }}</button>
                    </div>
                    <div>
                        <label for="dynaexp">Dynasties</label>
                        &nbsp;
                        <input type="checkbox" id="dynaexp" name="dynasties" checked="checked" v-model="dynaCheck"/>
                        &nbsp;
                        <button @click="openModal({modalName: 'dyna'})">{{ $t("showDyna") }}</button>
                    </div>
                    <div v-if="customBoards.length != 0">
                        <label for="customexp">Custom</label>
                        &nbsp;
                        <input type="checkbox" id="customexp" name="custom" checked="checked" v-model="customCheck"/>
                        &nbsp;
                        <button @click="openModal({modalName: 'custom'})">{{ $t("showCustom") }}</button>
                    </div>
                </td>
            </tr>
            <!-- Generator button -->
            <tr>
                <td class="has-text-centered">
                    <button class="button is-primary is-size-3" @click="selectBoards">{{ $t("generate") }}</button>
                </td>
            </tr>
            </tbody>
        </table>
        <!-- Chosen Nations -->
        <div class="block has-text-centered">
            <div v-for="nation in chosenNations" :key="nation.id">
                <p class="is-size-2">{{ nation }} <span class="is-size-6">{{ findOtherSide(nation) }}</span></p>
            </div>
        </div>

        <!-- Modals -->
        <v-modal element="core">
            <h3 class="is-3">Core</h3>
            <ul class="has-text-centered">
                <li v-for="nation in nationsCore" :key="nation.id" class="list-item">
                    {{ nation[0] }}
                </li>
            </ul>
        </v-modal>
        <v-modal element="dyna">
            <h3 class="is-3">Dynasties</h3>
            <ul class="has-text-centered">
                <li v-for="nation in nationsDyna" :key="nation.id" class="list-item">
                    {{ nation[0] }} / {{ nation[1] }}
                </li>
            </ul>
        </v-modal>
        <v-modal element="custom">
            <h3 class="is-3">Custom</h3>
            <ul class="has-text-centered">
                <li v-for="nation in customBoards" :key="nation.id" class="list-item">
                    {{ nation[0] }} / {{ nation[1] }}
                </li>
            </ul>
        </v-modal>
    </div>
</template>

<script>
import { modalMixin } from "@/vue/mixins/modalMixin";
import { i18nMixin } from "@/vue/mixins/i18nMixin";
import vModal from "@/vue/components/vModal";

export default {
    mixins: [
        i18nMixin,
        modalMixin
    ],
    components: {
        vModal
    },
    methods: {
        selectBoards() {
            let poolNations = [];
            this.chosenNations = [];

            if(this.coreCheck) {
                this.nationsCore.forEach(i => {
                    poolNations.push(i);
                });
            }

            if(this.dynaCheck) {
                this.nationsDyna.forEach(i => {
                    poolNations.push(i);
                });
            }

            if(this.customCheck) {
                this.customBoards.forEach(i => {
                    poolNations.push(i);
                });
            }

            //return if the array is empty
            if(poolNations.length === 0) {
                this.chosenNations = ['No modules selected'];
                return;
            }

            let rand = 0;

            do {
                rand = Math.floor(Math.random() * poolNations.length);
                this.chosenNations.push(poolNations[rand]);
                poolNations.splice(rand, 1);
            }
            while(this.chosenNations.length < this.playerAmount);

            this.chosenNations = this.selectBoardSide(this.chosenNations);
        },
        selectBoardSide(nationPairs) {
            const nations = [];
            for(let i = 0; i < nationPairs.length; i++) {
                const rand = Math.floor(Math.random() * 2);
                nations.push(nationPairs[i][rand]);
            }
            nations.sort();
            return nations;
        },
        findOtherSide(nation) {
            let otherSide = '';
            this.nationsDyna.forEach(board => {
                if (board.includes(nation)) {
                    otherSide = board.filter(e => nation !== e);
                }
            });
            this.customBoards.forEach(board => {
                if (board.includes(nation)) {
                    otherSide = board.filter(e => nation !== e);
                }
            });
            return otherSide[0];
        },
        createNewBoard() {

        }
    },
    data() {
        return {
            bggUrl: 'https://boardgamegeek.com/boardgame/126042/nations',
            playerAmount: 3,
            nationsCore: [
                ["Persia","Persia"],
                ["China","China"],
                ["Rome","Rome"],
                ["Greece","Greece"],
                ["Egypt","Egypt"]
            ],
            nationsDyna: [
                ["Mongolia","Portugal"],
                ["Venice","Korea"],
                ["Ethiopia","Poland"],
                ["Mali","India"],
                ["Arabs","America"],
                ["Japan","Vikings"]
            ],
            customBoards: [],
            chosenNations: [],
            coreCheck: true,
            dynaCheck: true,
            customCheck: false
        }
    }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
    "en": {
        "pageTitle": "Nations Randomizer",
        "amount": "Player amount",
        "modules": "Modules",
        "showCore": "Show Core nations",
        "showDyna": "Show Dynasties nations",
        "showCustom": "Show Custom nations",
        "generate": "Randomize"
    },
    "fi": {
        "pageTitle": "Nations Randomizer",
        "amount": "Pelaajien määrä",
        "modules": "Moduulit",
        "showCore": "Näytä Peruspelin valtiot",
        "showDyna": "Näytä Dynasties valtiot",
        "showCustom": "Näytä Omavalmisteiset valtiot",
        "generate": "Arvo valtiot"
    }
}
</i18n>
